export const BLOCK_NAME = 'b-list-card'

export const NAMESPACE = {
  slotContainer: `${BLOCK_NAME}__slots`,
  slotContainerLoaded: `${BLOCK_NAME}__slots_loaded`,
  selectorMountSelects: `${BLOCK_NAME}__mount-selects`,
  appointmentBox: `${BLOCK_NAME}__appointment-box_js`,
  appointmentService: `${BLOCK_NAME}__appointment-service`,
  observerContainerSlots: 'data-observer-container="slots"',
}
